import React from 'react';
import styles from '../../styles/GeneracionCargosAutomaticosStyles/GeneracionCargosAutomaticos.module.css';

function SummaryModal({ data, onClose }) {
  const { 
    total_estudiantes_procesados = 0,
    cargos_generados = 0,
    cargos_duplicados = 0,
    monto_total = 0,
    estudiantes_afectados = [],
    formData = {},
    // Nuevos campos de becas
    cargos_con_beca = 0,
    ahorro_total_becas = 0,
    monto_total_original = 0,
    becas_aplicadas = []
  } = data;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>
          <h2 className={styles.modalTitle}>Resumen de Cargos Generados</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div className={styles.modalContent}>
          {/* Información de configuración */}
          <div className={styles.summarySection}>
            <h3 className={styles.sectionTitle}>Configuración Aplicada</h3>
            <div className={styles.summaryGrid}>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Ciclo Escolar:</span>
                <span className={styles.summaryValue}>{formData.ciclo}</span>
              </div>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Campus:</span>
                <span className={styles.summaryValue}>{formData.campus}</span>
              </div>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Concepto de Cobro:</span>
                <span className={styles.summaryValue}>{formData.concepto}</span>
              </div>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Sección:</span>
                <span className={styles.summaryValue}>{formData.seccion}</span>
              </div>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Fecha de Aplicación:</span>
                <span className={styles.summaryValue}>{formData.fechaAplicacion}</span>
              </div>
              <div className={styles.summaryItem}>
                <span className={styles.summaryLabel}>Fecha de Vencimiento:</span>
                <span className={styles.summaryValue}>{formData.fechaVencimiento}</span>
              </div>
            </div>
          </div>

          {/* Estadísticas */}
          <div className={styles.summarySection}>
            <h3 className={styles.sectionTitle}>Resultados</h3>
            <div className={styles.statsGrid}>
              <div className={styles.statCard}>
                <div className={styles.statIcon} style={{ backgroundColor: '#e3f2fd' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#1976d2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                    <path d="M16 3.13a4 4 0 010 7.75"/>
                  </svg>
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{total_estudiantes_procesados}</div>
                  <div className={styles.statLabel}>Estudiantes Procesados</div>
                </div>
              </div>

              <div className={styles.statCard}>
                <div className={styles.statIcon} style={{ backgroundColor: '#e8f5e9' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32">
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{cargos_generados}</div>
                  <div className={styles.statLabel}>Cargos Generados</div>
                </div>
              </div>

              <div className={styles.statCard}>
                <div className={styles.statIcon} style={{ backgroundColor: '#fff3e0' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#f57c00">
                    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>{cargos_duplicados}</div>
                  <div className={styles.statLabel}>Cargos Duplicados (Omitidos)</div>
                </div>
              </div>

              <div className={styles.statCard}>
                <div className={styles.statIcon} style={{ backgroundColor: '#f3e5f5' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#7b1fa2">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
                  </svg>
                </div>
                <div className={styles.statContent}>
                  <div className={styles.statValue}>${monto_total.toFixed(2)}</div>
                  <div className={styles.statLabel}>Monto Total Generado</div>
                </div>
              </div>
            </div>
          </div>

          {/* Resumen de Becas Aplicadas */}
          {cargos_con_beca > 0 && (
            <div className={styles.summarySection}>
              <h3 className={styles.sectionTitle}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '20px', height: '20px', marginRight: '8px' }}>
                  <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
                </svg>
                Becas Aplicadas
              </h3>
              <div className={styles.becaSummaryBox} style={{ marginBottom: '16px' }}>
                <div className={styles.becaSummaryIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
                  </svg>
                </div>
                <div className={styles.becaSummaryContent}>
                  <span className={styles.becaSummaryTitle}>Descuento Total por Becas</span>
                  <div className={styles.becaSummaryValues}>
                    <span>Cargos con Beca: <strong>{cargos_con_beca}</strong></span>
                    <span>Monto Original: <strong>${(monto_total_original || (monto_total + ahorro_total_becas)).toFixed(2)}</strong></span>
                    <span className={styles.becaAhorro}>Ahorro: <strong>-${ahorro_total_becas.toFixed(2)}</strong></span>
                  </div>
                </div>
              </div>
              
              {becas_aplicadas && becas_aplicadas.length > 0 && (
                <div className={styles.becasDetailList}>
                  <h4 style={{ fontSize: '14px', color: '#37474f', marginBottom: '8px' }}>Detalle por Beca:</h4>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {becas_aplicadas.map((beca, idx) => (
                      <span key={idx} className={styles.becaTag} style={{ 
                        background: '#e3f2fd', 
                        padding: '6px 12px', 
                        borderRadius: '16px', 
                        fontSize: '13px',
                        color: '#1565c0'
                      }}>
                        {beca.nombre}: {beca.cantidad} estudiantes
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Lista de estudiantes afectados */}
          {estudiantes_afectados && estudiantes_afectados.length > 0 && (
            <div className={styles.summarySection}>
              <h3 className={styles.sectionTitle}>
                Estudiantes Afectados ({estudiantes_afectados.length})
              </h3>
              <div className={styles.studentsTable}>
                <div className={styles.tableHeader}>
                  <div className={styles.tableHeaderCell}>Matrícula</div>
                  <div className={styles.tableHeaderCell}>Nombre</div>
                  <div className={styles.tableHeaderCell}>Sección</div>
                  <div className={styles.tableHeaderCell}>Estado</div>
                </div>
                <div className={styles.tableBody}>
                  {estudiantes_afectados.slice(0, 10).map((estudiante, index) => (
                    <div key={index} className={styles.tableRow}>
                      <div className={styles.tableCell}>{estudiante.matricula}</div>
                      <div className={styles.tableCell}>{estudiante.nombre}</div>
                      <div className={styles.tableCell}>{estudiante.seccion}</div>
                      <div className={styles.tableCell}>
                        <span className={styles.statusBadge}>
                          {estudiante.cargo_generado ? 'Generado' : 'Duplicado'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                {estudiantes_afectados.length > 10 && (
                  <div className={styles.tableFooter}>
                    Y {estudiantes_afectados.length - 10} estudiantes más...
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Mensaje de éxito */}
          <div className={styles.successMessage}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <span>
              Los cargos se han generado exitosamente y están disponibles en el sistema.
            </span>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.closeModalButton} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default SummaryModal;
